import { t } from "i18next";
import { AppInputSwitcher } from "../../components/Layouts/AppInputSwitcher/AppInputSwitcher";
import React, { useEffect, useState } from "react";
import BookingGetters from "../../store/onlineBooking/getters";
import { PaymentTypesDetails } from "../../components/Layouts/BookingForm/PaymentTypesDetails";
import { useTranslation } from "react-i18next";
import { TextResource } from "../../@types/DTO/AppSetting";
import i18n from "../../config/i18n";
import { useSearchParams } from "react-router-dom";

function NewPersonalDetails({
  reservationSourcePayNow,
  reservationSourcePayLater,
  extrasSelected,
  updateVehiclePrice,
  updateSelectedPrice,
  updateUserPrimaryDetails,
  firstName,
  lastName,
  email,
  phoneNo,
  emailError,
  emailRef,
  phoneRef,
  phoneError,
  onPaymentTypeChange,
}) {
  const { t: translate } = useTranslation();
  const appSettings = BookingGetters.getAppSettings();
  const [reservationCancelMsgInPayment, setReservationCancelMsgInPayment] =
    useState<String>("");
  const showOnePayMethodTwoPrice =
    appSettings && appSettings["showOnePayMethodTwoPrice"];

  const userId = localStorage.getItem("userID");
  const isInvalidUser =
    !userId || userId === "null" || userId === "" || userId === "undefined";
  const istabletScreen = window.innerWidth > 768 && window.innerWidth < 1510;
  const [searchParams] = useSearchParams();
  const scriptChannel = searchParams.get("scriptChannel") ?? "";
  const isInvalidScriptChannelResSource =
    searchParams.get("isInvalidScriptChannelResSource") == "true"
      ? true
      : false;
  const handleChange = (key, value) => {
    updateUserPrimaryDetails(key, value);
  };
  const [personalDetailsLabel, setPersonalDetailsLabel] = useState<String>("");
  const [personalDetailsLabelRes, setPersonalDetailsLabelRes] =
    useState<String>("");
  const [personalDetailsHeader, setPersonalDetailsHeader] =
    useState<string>("");
  const lang = i18n.language;
  const textResource = BookingGetters.getTextResourceDetailsBasedOnLang();
  const data = textResource?.[lang]?.flatMap((item) => item.data || []) || [];
  const isSmallScreen = window.innerWidth <= 768;
  useEffect(() => {
    const dataMap = Object.fromEntries(
      (data ?? []).map((item) => [item.key, item.body])
    );
    setPersonalDetailsHeader(dataMap["personalDetailsHeader"] || "");
    setPersonalDetailsLabel(
      dataMap["personalDetailsLabel"] || translate("Personal Details")
    );
    setPersonalDetailsLabelRes(
      dataMap["personalDetailsLabelRes"] || "Dati Cliente"
    );
    const reservationCancelMsgInPaymentData = data.find(
      (item) => item.key === "reservationCancelMsgInPayment"
    )?.body;
    setReservationCancelMsgInPayment(reservationCancelMsgInPaymentData || "");
  }, [textResource, lang, translate]);

  const [isDesktop] = useState(window.innerWidth >= 1300);

  return (
    <>
      <div
        className={`bg-white box-border ${
          isSmallScreen ? "p-2" : "p-8"
        } justify-center`}
        style={{ paddingBottom: isSmallScreen ? "2rem" : "" }}
      >
        <h2
          className={"text-black text-base mt-2 font-medium "}
          dangerouslySetInnerHTML={{ __html: String(personalDetailsHeader) }}
        />
        <h2
          className="text-xl text-black pb-8 font-bold mt-[5px]"
          style={{
            paddingLeft: isSmallScreen ? ".8rem" : "",
            paddingTop: isSmallScreen ? "2rem" : "",
          }}
        >
          {userId !== null && userId !== "null" && userId !== ""
            ? personalDetailsLabelRes
            : personalDetailsLabel}
        </h2>
        <div
          className={`grid sm:grid-cols-2 ${
            istabletScreen ? "md:grid-cols-2" : "md:grid-cols-3"
          } gap-4`}
        >
          <AppInputSwitcher
            type="text"
            className={`h-20 sm:w-full box-border ${
              isSmallScreen ? "px-2" : "px-8"
            }`}
            required={true}
            label={t("First Name")}
            key="firstName"
            value={firstName || ""}
            onchange={(e) => handleChange("firstName", e.toString())}
          />
          <AppInputSwitcher
            type="text"
            required={true}
            className={`h-20 sm:w-full box-border ${
              isSmallScreen ? "px-2" : "px-8"
            }`}
            label={t("Last Name")}
            key="lastName"
            value={lastName || ""}
            onchange={(e) => handleChange("lastName", e.toString())}
          />
          <div className="w-full">
            <AppInputSwitcher
              type="email"
              required={true}
              className={`h-20 sm:w-full box-border ${
                isSmallScreen ? "px-2" : "px-8"
              }`}
              label={t("Email")}
              key="email"
              value={email || ""}
              onchange={(e) => handleChange("email", e.toString())}
              inputRef={emailRef}
            />
            {emailError && (
              <p
                style={{ color: "red", fontStyle: "italic" }}
                className="text-sm"
              >
                {emailError}
              </p>
            )}
          </div>
          <div>
            <AppInputSwitcher
              type="mobile"
              required={appSettings?.markPhoneNoRequiredForPrivate}
              className={`h-20 sm:w-full box-border ${
                isSmallScreen ? "px-2" : "px-8"
              }`}
              label={t("Mobile Number")}
              key="telephone"
              value={phoneNo || ""}
              onchange={(e) => handleChange("telephone", e.toString())}
              inputRef={phoneRef}
            />
            {phoneError && (
              <p
                style={{ color: "red", fontStyle: "italic" }}
                className="text-sm"
              >
                {phoneError}
              </p>
            )}
          </div>
        </div>
      </div>
      {(isInvalidUser &&
        !appSettings?.showAllPayOptionsInResArea &&
        !showOnePayMethodTwoPrice) ||
      !!(scriptChannel && isInvalidScriptChannelResSource && isInvalidUser) ||
      (!showOnePayMethodTwoPrice &&
        reservationSourcePayNow === "false" &&
        reservationSourcePayLater === "false" &&
        isInvalidUser) ? (
        <div className="bg-white box-border p-10">
          <PaymentTypesDetails
            reservationSourcePayNow={reservationSourcePayNow}
            reservationSourcePayLater={reservationSourcePayLater}
            extrasPrice={extrasSelected?.extrasPrice}
            updateVehiclePrice={updateVehiclePrice}
            updateSelectedPrice={updateSelectedPrice}
            onPaymentTypeChange={onPaymentTypeChange}
          />
        </div>
      ) : (
        <>
          {reservationCancelMsgInPayment && (
            <div
              className={`flex bg-white ${
                isDesktop
                  ? "px-4 grow max-w-[30%] md:ml-4"
                  : "justify-center px-4 py-4 mb-4 md:mb-0 md:mr-4"
              } text-sm relative`}
            >
              <div
                className={`flex-1 p-4 flex items-center justify-center text-center text-sm font-bold`}
              >
                <div>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: reservationCancelMsgInPayment,
                    }}
                  />
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
}

export default NewPersonalDetails;
